// eslint-disable-next-line import/no-unresolved
import ApiSearchResponse from 'prismic-javascript/types/ApiSearchResponse'

export const prismicHomePageContent: ApiSearchResponse = {
  page: 1,
  results_per_page: 20,
  results_size: 2,
  total_results_size: 2,
  total_pages: 1,
  next_page: 'null',
  prev_page: 'null',
  results: [
    {
      id: 'Xvyn1REAACMAsLcN',
      uid: 'null',
      type: 'home_page_updates',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvyn1REAACMAsLcN%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-07-01T15:12:26+0000',
      last_publication_date: '2021-01-06T15:49:47+0000',
      slugs: ['africa-rainfall-project-makes-plans-for-data-storing-and-sharing', 'this-is-how-a-global-community-unites-to-find-cancer-biomarkers.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        body: [
          {
            primary: {
              subject: 'World Community Grid complete restart',
              summary: 'World Community Grid finished the alpha testing, and is restarting on April 13.',
              date: '2023-04-13',
              image: {
                url: '/images/prismic/hundred_percent_complete.png',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=786',
            },
          },
          {
            primary: {
              subject: 'The Dylan Bucci Grid Computing Club at Sisler Cyber Academy',
              summary:
                'Sisler High School Cyber Academy (Winnipeg, MB) has expanded their partnership with World Community Grid by starting a computing club to honor one of their late classmates.',
              date: '2023-04-17',
              image: {
                url: '/images/prismic/sisler_academy.png',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=787',
            },
          },
          {
            primary: {
              subject: 'New team member and research projects at SCC',
              summary:
                'The SCC team shared news about the next phase of their research and introduced a new team member who will help with computational modeling for developing new cancer-treating drugs.',
              date: '2022-04-06',
              image: {
                url: '/images/prismic/scc_update_child_in_cape.png',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=785',
            },
          },
        ],
      },
    },
    {
      id: 'Xvu1qxEAACMArIvY',
      uid: 'null',
      type: 'home_page_hero',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvu1qxEAACMArIvY%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-06-30T22:02:11+0000',
      last_publication_date: '2021-01-05T19:32:17+0000',
      slugs: ['home--world-community-grid', 'kevin--home--world-community-grid', 'aids-is-constantly-evolving.so-are-the-tools-to-fight-it.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        page_title: 'Home | World Community Grid',
        page_description:
          'World Community Grid enables anyone with a computer or Android device to donate their unused computing power to advance cutting-edge scientific research on topics related to health and sustainability.',
        social_image: '/images/logo_images/wcg_logo_square_new_200x200.png',
        background_image: {
          url: '/images/prismic/transitionBig.jpg',
        },
        headline: [
          {
            type: 'paragraph',
            text: 'Celebrating 18 years of World Community Grid',
            spans: [],
          },
          {
            type: 'paragraph',
            text: '',
            spans: [],
          },
        ],
        summary: 'Accelerating science by creating a supercomputer empowered by a global community of volunteers.',
        text_color: 'White',
        image_overlay_style: 'None',
        body: [
          {
            slice_type: 'learn_more',
            primary: {
              link: 'https://www.worldcommunitygrid.org/about_us/viewNewsArticle.do?articleId=757',
            },
          },
          /* prettier-ignore */
          /* This enables the "join" a project button on the home page, uncomment to add it back
          {
            slice_type: 'contribute_link',
            primary: {
              project_short_name: 'opn1',
            },
          },*/
        ],
      },
    },
  ],
}
